(() => {
  'use strict';
  if (customElements.get('dmr-finishes')) return;
  const instances = new Set();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
  function sync() {
    frame = 0;
    let chosen = null, score = 0;
    const blocked = document.hidden || document.querySelector('dialog[open]');
    for (const page of instances) {
      for (const video of page.querySelectorAll('[data-dmr-loop]')) {
        if (blocked || video.closest('[hidden]') || page.userPaused.has(video)) continue;
        const r = video.getBoundingClientRect();
        const visible = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
        if (r.width < 1 || r.left >= innerWidth || r.right <= 0 || visible < Math.min(r.height * .45, 150)) continue;
        const forced = page.forced === video;
        if (!forced && (reduced.matches || navigator.connection?.saveData)) continue;
        const value = visible - Math.abs((r.top + r.bottom) / 2 - innerHeight / 2) * .2 + (forced ? 10000 : 0);
        if (value > score) { chosen = video; score = value; }
      }
    }
    for (const page of instances) for (const video of page.querySelectorAll('[data-dmr-loop]')) {
      if (video === chosen) {
        if (!video.getAttribute('src')) video.src = video.dataset.src;
        if (video.paused) video.play().catch(() => {});
      } else video.pause();
    }
  }
  class DmrMediaPage extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController(); this.userPaused = new Set(); this.forced = null;
      this.dialog = this.querySelector('dialog'); this.fullImage = this.querySelector('[data-dmr-full-image]'); this.fullVideo = this.querySelector('[data-dmr-full-video]');
      this.currentItems = []; this.currentIndex = 0;
      instances.add(this);
      this.on(this, 'click', event => {
        if (event.target.closest('[data-dmr-close]')) this.dialog.close();
        const step = event.target.closest('[data-dmr-dialog-step]');
        if (step) this.stepModal(Number(step.dataset.dmrDialogStep));
      });
      this.on(this.dialog, 'close', () => { this.stopFull(); schedule(); });
      this.on(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      });
      this.on(this.dialog, 'keydown', event => {
        if (event.target === this.fullVideo) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.stepModal(event.key === 'ArrowLeft' ? -1 : 1); }
      });
      this.swipe(this.querySelector('.dmr-guide-stage'), direction => this.stepModal(direction));
      this.on(document, 'visibilitychange', () => { if (document.hidden) this.fullVideo.pause(); schedule(); });
      this.on(window, 'scroll', schedule, { passive: true }); this.on(window, 'resize', schedule);
      this.on(reduced, 'change', schedule);
      this.observer = new MutationObserver(schedule); this.observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
      this.querySelectorAll('[data-dmr-loop]').forEach(video => {
        video.muted = true;
        const update = () => {
          const card = video.closest('[data-dmr-card]'); if (!card) return;
          card.classList.toggle('is-playing', !video.paused);
          const button = card.querySelector('[data-dmr-toggle]');
          if (button) { button.textContent = video.paused ? '▶' : 'Ⅱ'; button.setAttribute('aria-label', video.paused ? this.dataset.play : this.dataset.pause); }
        };
        this.on(video, 'play', update); this.on(video, 'pause', update);
        this.on(video, 'error', () => { this.userPaused.add(video); update(); });
      });
      this.setup(); schedule();
    }
    on(target, name, callback, options = {}) { target?.addEventListener(name, callback, { ...options, signal: this.controller.signal }); }
    swipe(surface, callback) {
      let start = null;
      this.on(surface, 'touchstart', e => { start = { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY }; }, { passive: true });
      this.on(surface, 'touchend', e => {
        if (!start) return;
        const x = e.changedTouches[0].clientX - start.x, y = e.changedTouches[0].clientY - start.y; start = null;
        if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y) * 1.3) { callback(x < 0 ? 1 : -1); surface.dataset.swiped = String(Date.now()); }
      }, { passive: true });
      this.on(surface, 'click', e => { if (Date.now() - Number(surface.dataset.swiped || 0) < 350) { e.preventDefault(); e.stopPropagation(); } }, { capture: true });
    }
    open(items, item) {
      this.currentItems = items;
      this.currentIndex = Math.max(0, items.indexOf(item));
      if (!this.dialog.open) this.dialog.showModal();
      this.showMedia(); schedule();
    }
    showMedia() {
      const item = this.currentItems[this.currentIndex]; if (!item) return;
      this.stopFull();
      const video = item.dataset.kind === 'video';
      this.fullImage.hidden = video; this.fullVideo.hidden = !video;
      this.querySelector('[data-dmr-title]').textContent = item.dataset.combo || '';
      if (video) {
        this.fullVideo.poster = item.dataset.poster || '';
        this.fullVideo.src = item.dataset.src; this.fullVideo.muted = true;
        this.fullVideo.play().catch(() => {});
      } else { this.fullImage.src = item.dataset.src; this.fullImage.alt = item.dataset.combo || ''; }
      this.querySelector('[data-dmr-dialog-count]').textContent = `${this.currentIndex + 1} / ${this.currentItems.length}`;
      this.querySelectorAll('[data-dmr-dialog-step]').forEach(button => button.hidden = this.currentItems.length < 2);
    }
    stepModal(step) { if (!this.currentItems.length) return; this.currentIndex = (this.currentIndex + step + this.currentItems.length) % this.currentItems.length; this.showMedia(); }
    stopFull() { this.fullVideo.pause(); this.fullVideo.removeAttribute('src'); this.fullVideo.load(); }
    disconnectedCallback() {
      this.controller?.abort(); this.observer?.disconnect(); this.resizeObserver?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
      if (this.dialog?.open) this.dialog.close();
      this.controller = null; instances.delete(this); schedule();
    }
  }
  class DmrFinishes extends DmrMediaPage {
    setup() {
      this.querySelectorAll('[data-dmr-carousel]').forEach(carousel => {
        const slides = [...carousel.querySelectorAll('[data-dmr-slide]')]; let index = 0;
        const move = step => {
          index = (index + step + slides.length) % slides.length;
          slides.forEach((slide, i) => slide.hidden = i !== index);
          const count = carousel.querySelector('[data-dmr-counter]'); if (count) count.textContent = `${index + 1} / ${slides.length}`;
          schedule();
        };
        this.on(carousel, 'click', event => {
          const previousNext = event.target.closest('[data-dmr-step]');
          if (previousNext) move(Number(previousNext.dataset.dmrStep));
          const open = event.target.closest('[data-dmr-open]');
          if (open) this.open(slides, open.closest('[data-dmr-slide]'));
          if (event.target.closest('[data-dmr-video-cta]')) {
            const videos = slides.filter(slide => slide.dataset.kind === 'video');
            if (videos.length) this.open(videos, videos[0]);
          }
        });
        if (slides.length > 1) this.swipe(carousel.querySelector('[data-dmr-slides]'), move);
      });
    }
  }
  class DmrGallery extends DmrMediaPage {
    setup() {
      this.wall = this.querySelector('.dmr-gallery-wall');
      this.cards = [...this.querySelectorAll('[data-dmr-card]')].sort((a, b) => (Date.parse(b.dataset.added) || 0) - (Date.parse(a.dataset.added) || 0));
      this.cards.forEach(card => this.wall.append(card));
      this.filter = 'all';
      this.on(this, 'click', event => {
        const filter = event.target.closest('[data-dmr-filter]');
        if (filter) {
          this.filter = filter.dataset.dmrFilter;
          this.querySelectorAll('[data-dmr-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
          this.cards.forEach(card => card.hidden = !this.matches(card)); this.layout(); schedule();
        }
        const open = event.target.closest('[data-dmr-open]');
        if (open && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) { event.preventDefault(); this.open(this.cards.filter(card => this.matches(card)), open.closest('[data-dmr-card]')); }
        const toggle = event.target.closest('[data-dmr-toggle]');
        if (toggle) {
          const video = toggle.closest('[data-dmr-card]').querySelector('video');
          if (!video.paused) { this.userPaused.add(video); this.forced = null; video.pause(); }
          else { this.userPaused.delete(video); this.forced = video; }
          schedule();
        }
      });
      this.resizeObserver = new ResizeObserver(() => this.layout()); this.resizeObserver.observe(this.wall);
      this.cards.forEach(card => this.on(card.querySelector('img'), 'load', () => this.layout()));
      this.on(document, 'shopify:block:select', event => {
        const card = event.target.closest('[data-dmr-card]');
        if (card && this.contains(card)) { this.filter = 'all'; this.cards.forEach(c => c.hidden = false); this.layout(); card.scrollIntoView({ block: 'center' }); }
      });
      this.layout();
    }
    matches(card) { return this.filter === 'all' || (this.filter === 'videos' ? card.dataset.kind === 'video' : card.dataset.category === this.filter); }
    layout() {
      const style = getComputedStyle(this.wall), gap = parseFloat(style.rowGap), unit = parseFloat(style.gridAutoRows);
      this.cards.forEach(card => { if (!card.hidden) card.style.gridRowEnd = `span ${Math.ceil((card.querySelector('[data-dmr-open]').getBoundingClientRect().height + gap) / (unit + gap))}`; });
    }
  }
  customElements.define('dmr-finishes', DmrFinishes);
  customElements.define('dmr-gallery', DmrGallery);
})();
